<template>
    <div class="widget">
        <div class="widget-content widget-channel-container" v-if="messages.length > 0">
            <news-feed-item v-for="message in messages"
                v-bind:key="`channel-message-${message.channelId}-${message.id}`"
                v-bind:hidden="!message.text"
                v-bind:id="message.id"
                v-bind:channelId="message.channelId"
                v-bind:channelUsername="message.channelUsername"
                v-bind:channelName="message.channelName"
                v-bind:channelAvatarVersion="message.channelAvatarVersion"
                v-bind:text="message.text"
                v-bind:date="message.date" />
        </div>
        <div class="widget-content widget-channel-container" v-else>
            <news-feed-skeleton v-for="i in 4" v-bind:key="`news-skeleton-${i}`" />
        </div>
    </div>
</template>

<script>
import { getNews } from '~/api/news';
import { NEWS_CHANNEL_IDS } from './channels.js';
import NewsFeedItem from './NewsFeedItem.vue';
import NewsFeedSkeleton from './NewsFeedSkeleton.vue';

export default {
    data() {
        return {
            messages: [],
        };
    },

    watch: {
        '$i18n.locale': function () {
            this.getNewsInfo();
        },
    },

    mounted() {
        this.getNewsInfo();
    },

    methods: {
        async getNewsInfo() {
            const lang = this.$i18n.locale;
            const limit = 24;

            this.messages = [];

            try {
                const { channels, posts } = await getNews(NEWS_CHANNEL_IDS[lang], limit);

                this.messages = posts.map((item) => {
                    const channelInfo = channels[item.channel_id];
                    return {
                        channelId: item.channel_id,
                        channelUsername: channelInfo.username,
                        channelName: channelInfo.title,
                        channelAvatarVersion: channelInfo.avatar_version,
                        id: item.post_id,
                        date: item.date,
                        text: item.text,
                    };
                });
            } catch {
                // The news API is a third-party service that occasionally answers 5xx; keep the feed empty
                this.messages = [];
            }
        },
    },

    components: {
        NewsFeedItem,
        NewsFeedSkeleton,
    },
};
</script>

<style lang="scss">
.widget-channel-container {
    max-height: 600px;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

@media screen and (max-width: 480px) {
    .widget {
        width: 100%;
    }
}
</style>
